import React from "react"
import { ResultRowShell } from "./result_row_shell"
import { CategoryIcon } from "../category_icon"
import type { SearchRowComponent } from "./types"

// A dictionary entry result. Kept as its own component so it can grow (pronunciation, part of speech)
// independently of the other types.
export const CodexRow: SearchRowComponent = ({ hit, position, onSelect }) => (
  <ResultRowShell hit={hit} position={position} onSelect={onSelect}>
    <CategoryIcon category="Codex" className="shrink-0 text-secondary-400" />
    <span className="truncate">
      {hit.name} &middot;{" "}
      <em className="text-muted-foreground">{hit.translation}</em>
    </span>
  </ResultRowShell>
)
